import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { PolicyContainer } from '../common/PolicyContainer';

import styles from './KYC.module.scss';

export const KYC: FC = () => {
  const { t } = useTranslation('common');

  return (
    <PolicyContainer className={styles.root}>
      <h1>{t('footer.links.kyc')}</h1>
      <p>
        <strong>LEAD GATES LTD,</strong> a Company incorporated under the law of Republic of Bulgaria, with the company
        number 207064979, having its registered office address Apt. 20, Fl. 6, 14 Miziya Str., Town of Plovdiv
        (hereinafter – «SMART GATES», «We», «Our», «Company») is committed to the highest in preventing criminal
        activities and determining the level of risk for each of our clients (collectively referred to as «Know Your
        Customer» or «KYC» hereinafter - the Policy).
      </p>

      <h2>Objectives</h2>
      <p>
        In accordance with national and international KYC standards, SMART GATES strictly adheres to the principle of
        good faith. While we respect the rights of our clients to privacy, we are obligated to exercise special care in
        collecting information about their identity and the activities they engage in. The SMART GATES policy aims to
        reduce the level of risk when interacting with our clients by collecting and analyzing their personal
        information, in compliance with all applicable requirements according to the current legislation worldwide and
        its subsidiary acts. The policy is based on the principles of good faith partnership: if we know and trust our
        clients, they, in turn, know us and trust us. We strive not only to obtain evidence confirming and verifying the
        identity of potential clients and their current plans and objectives but also to ensure that their activities
        are legal and do not violate international rules and laws.
      </p>

      <h3>Interaction with Clients</h3>
      <ol>
        <li>
          Proper Customer Due Diligence (CDD) is one of the international standards for preventing illegal activities.
          According to CDD, SMART GATES establishes its own verification procedures within this Policy. Therefore, all
          clients, in accordance with the Policy, must provide documents according to the list specified below:
          <p style={{ textDecoration: 'underline', fontStyle: 'italic' }}>Requirements for individuals:</p>
          <ul>
            <li>
              High-resolution copies of passport pages with a photograph, full name, nationality, date and place of
              birth, passport issuance and expiration dates, passport number, issuing country, and signature, or copies
              of ID cards/driver&apos;s licenses containing all the aforementioned information;
            </li>
            <li>
              Utility bill (e.g., electricity, phone, etc.) or bank statement indicating the date (not older than the
              past three months), registered name, permanent address, and mailing address;
            </li>
            <li>High-resolution copy of the credit card, in case the client uses it to fund the account.</li>
          </ul>
          <p style={{ textDecoration: 'underline', fontStyle: 'italic' }}>Requirements for organizations:</p>
          <ul>
            <li>High-resolution copy of the company registration certificate;</li>
            <li>Copy of the memorandum and articles of association of the organization;</li>
            <li>
              Certificate of authority indicating the names of directors and shareholders (not older than 6 months);
            </li>
            <li>Document indicating the registered address of the company;</li>
            <li>Copies of passports of all directors and shareholders of the company;</li>
            <li>Addresses of all directors.</li>
          </ul>
        </li>

        <li>
          SMART GATES is not authorized and not obligated to determine whether the document provided by the client for
          identification is legal. However, in case of obvious discrepancies in the obtained information, SMART GATES
          reserves the right to request additional identification documents from the client. If the client refuses to
          provide the required information when necessary or attempts to mislead SMART GATES, the service may be denied
          to that client.
        </li>

        <li>
          SMART GATES reserves the right to periodically verify the client&apos;s identity, especially if the client has
          changed personal details or if their activities seem suspicious (uncharacteristic for a specific client).
          Additionally, SMART GATES reserves the right to request updated documents from clients, even if they have
          previously undergone verification.
        </li>
      </ol>

      <h3>Frequency</h3>
      <p>
        In order to ensure the accuracy of client data, SMART GATES, at its discretion and with individually established
        periodicity, has the right to request any information and documents from its clients. In this regard, if a
        client wishes to continue using SMART GATES services, they cannot refuse to provide the requested information.
      </p>

      <h3>Disclaimer</h3>
      <p>
        At any time during the provision of services, SMART GATES has the right, at its discretion and based on this
        Policy, to request documents from the client (a list determined solely by SMART GATES, including the form of the
        documents to be provided) to confirm any actions (or transactions) already carried out by the client or intended
        to be carried out by the client. At the same time, SMART GATES reserves the exclusive right to unilaterally
        reject the client&apos;s application and/or terminate further service provision without providing any
        explanation for the reasons.
      </p>

      <h3>Final Provisions</h3>
      <ol>
        <li>
          SMART GATES may disclaim potential legal liability in a situation where the provided services and/or products
          are used by the client for illegal activities.
        </li>
        <li>
          If we identify signs of suspicious activity by a client that may be associated with illegal activities,
          information about it will be reported to the competent authorities.
        </li>
        <li>
          If you have any questions regarding this Policy, please contact us via the available communication channels or
          by e-mail <strong>support@smart-gates.net.</strong>
        </li>
        <li>
          SMART GATES reserves the right to change and/or supplement this Policy unilaterally without notifying the
          Client.
        </li>
        <li>
          In case of any discrepancies between different forms (print, electronic, etc.) and/or revision dates of this
          Policy, the official and effective version posted on the official information resources of SMART GATES shall
          prevail.
        </li>
      </ol>

      <p style={{ marginTop: '100px' }}>
        <strong>Publication date:</strong> 05/29/2023
      </p>
    </PolicyContainer>
  );
};
